/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MachineSerial model module.
 * @module model/MachineSerial
 * @version 0.0.1
 */
class MachineSerial {
    /**
     * Constructs a new <code>MachineSerial</code>.
     * @alias module:model/MachineSerial
     */
    constructor() { 
        
        MachineSerial.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MachineSerial</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MachineSerial} obj Optional instance to populate.
     * @return {module:model/MachineSerial} The populated <code>MachineSerial</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MachineSerial();

            if (data.hasOwnProperty('serial')) {
                obj['serial'] = ApiClient.convertToType(data['serial'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MachineSerial</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MachineSerial</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['serial'] && !(typeof data['serial'] === 'string' || data['serial'] instanceof String)) {
            throw new Error("Expected the field `serial` to be a primitive type in the JSON string but got " + data['serial']);
        }

        return true;
    }


}



/**
 * @member {String} serial
 */
MachineSerial.prototype['serial'] = undefined;






export default MachineSerial;

